enum NotificationLevel {
  failure = "failure",
  success = "success",
}

export const failure = NotificationLevel.failure;
export const success = NotificationLevel.success;

export default NotificationLevel;
